// Library import
import {createRoot} from 'react-dom/client';
import {Table, Pagination, Alert} from 'react-bootstrap';
import Proptypes from 'prop-types';
import {useEffect, useState, useRef} from 'react';

// File Import
import Edit from '~/images/icon/edit.png';
import DeleteBlack from '~/images/icon/delete-black.png';
import CopyIcon from '~/images/icon/copy.svg';
import {formatDate} from '@/config/day';
import {postStatus, pageSizes} from '@/constant/global';
import {truncateString} from '@/config/mixins';

// Components Import
import {DeletePostModal, PostPreviewModal, CopyPostModal, Loading, CopySuccessModal} from '@/components';

const PostListView = ({data}) => {
    const url = new URL(window.location.href);
    const [posts, setPosts] = useState(data?.data || []);
    const [selectedItem, setSelectedItem] = useState({});
    const [loading, setLoading] = useState(false);
    const [typeParam, setTypeParam] = useState(null);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [postDetailModal, setPostDetailModal] = useState(false);
    const reloadTimer = 150000;
    const timerRef = useRef(null);
    const reloadType = sessionStorage.getItem("reloadType");
    const [pageSize, setPageSize] = useState(pageSizes[3]);
    const sizeParam = url.searchParams.get('size');
    const [clearSearch, setClearSearch] = useState('d-none');
    const [search, setSearch] = useState('');
    // const [errorSearch, setErrorSearch] = useState('');
    const searchParam = url.searchParams.get('search');
    const [showCopyModal, setShowCopyModal] = useState(false);
    const [showCopySucessModal, setShowCopySucessModal] = useState(false);

    useEffect(() => {
        setPosts(data?.data);
        setTypeParam(`${url.searchParams.get('type')}`);
        setPageSize(sizeParam && pageSizes.includes(sizeParam) ? sizeParam : pageSizes[3]);
        if (reloadType !== null) {
            handleRemainTime();
            timerRef.current = setInterval(handleRemainTime, 1000);
        }
        setSearch(searchParam ? searchParam : '');
        setClearSearch(searchParam ? '' : 'd-none');
        if(localStorage.getItem("post_info")) {
            setShowCopySucessModal(true);
        }
    }, []);

    const handlePostStatus = (status, created_at, scheduled_at) => {
        switch (status) {
            case postStatus['PUBLISHED']:
                return {status: '公開済み', class: 'lite-green', time: formatDate(scheduled_at, 'YYYY/MM/DD HH:mm')};

            case postStatus['UNPUBLISHED']:
                return {status: '未発表', class: 'lite-red', time: '---'};

            case postStatus['DRAFT']:
                return {status: '下書き', class: 'lite-blue', time: '---'};

            case postStatus['SCHEDULED']:
                return {status: 'スケジュール', class: 'lite-orange', time: formatDate(scheduled_at, 'YYYY/MM/DD HH:mm')};
        }
    };

    const handleClearInterval = () => {
        sessionStorage.clear();
        if(timerRef.current) {
            clearInterval(timerRef.current);
        }
    };

    const handleRemainTime = () => {
        let remainTimer = sessionStorage.getItem("remainTimer");
        remainTimer = remainTimer !== null ? remainTimer - 1000 : reloadTimer;
        if (remainTimer > 0) {
            sessionStorage.setItem("remainTimer", remainTimer);
        } else if (remainTimer == 0) {
            handleClearInterval();
            if (url.href.includes(`type=${reloadType}`)) {
                const searchStr = url.searchParams.get('search') ? ('search='+url.searchParams.get('search') + '&&') : ''; // Get param search
                const sizeStr = url.searchParams.get('size') ? ('&&size='+url.searchParams.get('size')) : ''; // Get size
                window.location.href = `/admin/posts?${searchStr}type=${reloadType}${sizeStr}`;
            }
        }
    };

    const handleChange = (event) => {
        const pageSize = event.target.value;
        const searchValue = searchParam ? `search=${search}&&` : '';
        setPageSize(pageSize);
        window.location.href = `/admin/posts?${searchValue}type=${typeParam}&&size=${pageSize}`;
    };

    const handleChangeSearch = (event) => {
        if (event.nativeEvent instanceof KeyboardEvent && (event.key === 'Enter' || event.code === 'Enter') && (search.trim().length > 0)) {
          handlePostSearch();
        } else {
          const searchValue = event.target.value;
          setSearch(searchValue);
          if (searchValue.trim().length > 0) {
            setClearSearch('');
            // setErrorSearch('');
          } else {
            setClearSearch('d-none');
          }
        }
    };

    const handleClearSearch = (event) => {
        const searchValue = '';
        setSearch(searchValue);
        handleChangeSearch({
            target: {
                name: 'post_search',
                value: searchValue
            }
        });
    };

    const handlePostSearch = (event) => {
        // if (search.trim().length === 0) {
        //     setErrorSearch('タイトルを入力してください');
        //     return;
        // }
        // setErrorSearch('');
        window.location.href = `/admin/posts?search=${search}&&type=${typeParam}&&size=${pageSize}`;
    };

    /**
     * Change page
     * @param object postLine Post item
     */
    const handleChangePage = (postLine) => {
        const searchStr = url.searchParams.get('search') ? ('search='+url.searchParams.get('search') + '&&') : ''; // Get param search
        const sizeStr = url.searchParams.get('size') ? ('&&size='+url.searchParams.get('size')) : ''; // Get size
        if (postLine && postLine.id) {
            window.open(`/admin/posts/${postLine?.id}/edit?${searchStr}type=${postLine?.type}${sizeStr}`, '_self'); // Edit
        } else {
            window.open(`/admin/posts/create?${searchStr}type=${typeParam}${sizeStr}`, '_self'); // Create
        }
    }

    return (
        <div className='page-wrapper px-4'>
            <div className='create-btn my-3 d-flex justify-content-end position-relative'>
                <div className='position-absolute start-0 search-control'>
                    <div className="d-flex position-relative">
                        <input name='post_search'
                            type="text"
                            placeholder="タイトル/担当者名入力で記事を検索する"
                            // className={`input-search form-control${errorSearch ? ' is-invalid' : ''}`}
                            className="input-search form-control"
                            value={search}
                            onChange={handleChangeSearch}
                            onKeyUp={handleChangeSearch}
                        />
                        {/* {errorSearch && (
                            <div className='invalid-feedback'>{errorSearch}</div>
                        )} */}
                        <button className='button primary ms-1' onClick={(event) => handlePostSearch(event)}
                            disabled={!search}>
                            <i className='material-icons text-white'>search</i>
                        </button>
                        <i className={`material-icons btn-clear ${clearSearch}`} onClick={(event) => handleClearSearch(event)}>clear</i>
                    </div>
                </div>
                <span className='my-auto me-3'>※掲載状況の自動更新は2-3分かかります</span>
                <a onClick={handleChangePage} className='button secondary w-auto ms-3'>
                    新規作成
                </a>
            </div>

            <div className={`search-result${searchParam ? ' d-inline-flex align-items-baseline flex-nowrap' : ' d-none'}`}> 
                <span className='text-nowrap me-3'>検索結果</span>
                <a href={`/admin/posts?type=${typeParam}`} className='button primary clear-search-btn'>クリア</a>
            </div>

            <div className='list-tabler-wrapper'>
                {/* Table heading show here */}
                <Table>
                    <thead>
                    <tr>
                        <th>ID</th>
                        <th>タイトル</th>
                        <th>作成日</th>
                        <th>掲載日</th>
                        <th className='text-center'>担当者</th>
                        <th>掲載状況</th>
                        <th></th>
                        <th className='text-center'>編集</th>
                        <th className='text-center'>削除</th>
                        <th className='text-center'>コピー</th>
                    </tr>
                    </thead>

                    {/* Table list data show here */}
                    <tbody>
                    {posts?.map((post, index) => (
                        <tr key={index}>
                            <td>{post?.id}</td>
                            <td>{truncateString(post?.title, 25)}</td>
                            <td>{formatDate(post?.created_at, 'YYYY/MM/DD HH:mm')}</td>
                            <td>{handlePostStatus(post?.status, post?.created_at, post?.scheduled_at)?.time}</td>
                            <td className='text-center'>{post?.user_name}</td>
                            <td>
                  <span
                      className={`button status-btn ${handlePostStatus(post?.status, post?.created_at, post?.scheduled_at)?.class}`}>
                    {handlePostStatus(post?.status, post?.created_at, post?.scheduled_at)?.status}
                  </span>
                            </td>
                            <td className='d-flex justify-content-center'>
                                <button
                                    className='button primary'
                                    onClick={() => {
                                        setSelectedItem(post);
                                        setPostDetailModal(true);
                                    }}
                                    style={{maxWidth: '110px'}}>
                                    プレビュー
                                </button>
                            </td>
                            <td className='icon-thumb text-center'>
                                <img
                                    src={Edit}
                                    onClick={() => handleChangePage(post)}
                                    // onClick={() => {
                                    //     window.open(`/admin/posts/${post?.id}/edit?type=${post?.type}`, '_self');
                                    // }}
                                    alt='Edit icon'
                                />
                            </td>
                            <td className='icon-thumb text-center'>
                                <img
                                    src={DeleteBlack}
                                    onClick={() => {
                                        setSelectedItem(post);
                                        setShowDeleteModal(true);
                                    }}
                                    alt='Delete icon'
                                />
                            </td>
                            <td className='icon-thumb text-center'>
                                <img src={CopyIcon} onClick={() => {setSelectedItem(post);setShowCopyModal(true)}} alt='Copy icon' />
                            </td>
                        </tr>
                    ))}
                    </tbody>
                </Table>

                {posts?.length === 0 && (
                    <Alert variant='secondary' className='text-center'>
                        該当するコンテンツはありません
                    </Alert>
                )}
            </div>

            {/* Pagination area */}
            <div className='page-header bg-white'>
                {data?.total > data?.per_page ? (
                    <Pagination className='mx-auto'>
                        <Pagination.First href={data?.first_page_url + '&&type=' + typeParam + '&&size=' + pageSize}/>
                        <Pagination.Prev href={data?.prev_page_url + '&&type=' + typeParam + '&&size=' + pageSize}/>

                        {data?.links.slice(1, -1)?.map((link, idx) => (
                            <Pagination.Item key={idx} href={link?.url + '&&type=' + typeParam + '&&size=' + pageSize} active={link?.active}>
                                {link?.label}
                            </Pagination.Item>
                        ))}

                        <Pagination.Next href={data?.next_page_url + '&&type=' + typeParam + '&&size=' + pageSize}/>
                        <Pagination.Last href={data?.last_page_url + '&&type=' + typeParam + '&&size=' + pageSize}/>
                    </Pagination>
                ) : (<div>&nbsp;</div>)}
                <div className={data?.total > pageSizes[0] ? 'justify-content-end' : 'd-none'}>
                    <span className='me-2'>1ページあたりのコンテンツ表示件数 :</span>
                    <select name='pageSizes' value={pageSize} onChange={(event) => handleChange(event)}>
                        {pageSizes?.map((option, idx) => (
                          <option key={idx} value={option}>
                            {option}
                          </option> 
                        ))}
                    </select>
                </div>
            </div>

            {/* Loading */}
            {loading && <Loading/>}

            {/* Delete post */}
            <DeletePostModal
                show={selectedItem?.id && showDeleteModal}
                typeParam={typeParam}
                postId={selectedItem?.id}
                pathImage={selectedItem?.original_image}
                items={selectedItem.items}
                handleClose={() => setShowDeleteModal(false)}
            />

            {/* Details post */}
            {selectedItem?.id && postDetailModal && (
                <PostPreviewModal show={selectedItem?.id && postDetailModal} post={selectedItem}
                                  handleClose={() => setPostDetailModal(false)}/>
            )}

        {/* Copy post */}
        {selectedItem?.id && showCopyModal && (
          <CopyPostModal
            show={selectedItem?.id && showCopyModal}
            handleClose={() => setShowCopyModal(false)}
            postList={posts}
            queryParam={{ search: search, type: typeParam, size: pageSize }}
            selectedItem={selectedItem}
          />
        )}

        {/* Copy Success Modal */}
        {showCopySucessModal && (
          <CopySuccessModal
            show={showCopySucessModal}
            handleClose={() => setShowCopySucessModal(false)}
          />
        )}
        </div>
    );
};

export default PostListView;

PostListView.prototype = {
    data: Proptypes.object
};

let element = null;

document.addEventListener('DOMContentLoaded', function (event) {
    if (!element !== null) {
        element = document.getElementById('PostListView');
        const data = element?.dataset?.posts && JSON.parse(element.dataset.posts);

        const root = element && createRoot(element);

        if (element) root.render(<PostListView data={data}/>);
    }
});
